var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveSecurityGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic security group",
    clipPath: "url(#clip0_9146_76167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic security groups"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9505 4.88906C13.4755 4.3224 13.7421 1.66406 10.0005 1.66406L2.13379 9.99739C3.13379 14.1474 5.64212 16.4724 10.0005 18.3307L17.8671 9.99739C18.1088 8.98906 18.2588 7.88073 18.3338 6.63906C18.3755 5.79739 17.7838 5.03073 16.9505 4.88906Z",
    fill: "#65B2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0004 1.66406V9.99739H2.13378C1.89211 8.98906 1.74211 7.88073 1.66711 6.63906C1.62544 5.79739 2.21711 5.03073 3.05044 4.88906C6.52544 4.3224 6.25878 1.66406 10.0004 1.66406Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8667 10C16.8667 14.15 14.3583 16.475 10 18.3333V10H17.8667Z",
    fill: "#FFFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSecurityGroups);
export default __webpack_public_path__ + "static/media/active-securityGroups.6d406f0efb021ddd5a7554d203b00c39.svg";
export { ForwardRef as ReactComponent };